import updateIn from 'transmute/updateIn';
import { ValueForKeyPath } from 'immutable-less/transmute';

interface updateIn {
  <
    Data,
    KeyPath extends readonly any[],
    Value = ValueForKeyPath<KeyPath, Data>,
  >(
    keyPath: KeyPath,
    updater: (value: Value) => Value,
    data: Data
  ): Data;

  (keyPath: readonly any[], value: unknown): <Data>(data: Data) => Data;
  <KeyPath extends readonly any[]>(
    key: KeyPath
  ): <Data, Value = ValueForKeyPath<KeyPath, Data>>(
    updater: (value: Value) => Value,
    data: Data
  ) => Data;
  (
    keyPath: readonly any[]
  ): (value: <Value>(value: Value) => Value) => <Data>(data: Data) => Data;
}

export default updateIn as updateIn;
